module.exports = __webpack_public_path__ + "static/media/mb-logo-full.cbdeabeb.svg";